<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('members')" :isNewButton="checkPermission('studentclubpresidentapplicationuser_store')"
                        @new-button-click="createFormShow()" :isFilter="false" >
                </Header>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('members')" :isNewButton="checkPermission('studentclubpresidentapplicationuser_store')"
                              @new-button-click="createFormShow()"
                              :isFilter="false"
                >
                </HeaderMobile>
            </template>
            <datatable :isLoading.sync="datatable.isLoading" :columns="datatable.columns" :rows="datatable.rows"
                       :total="datatable.total" :queryParams="datatable.queryParams" @on-page-change="onPageChange"
                       @on-sort-change="onSortChange" @on-per-page-change="onPerPageChange" v-show="datatable.showTable">
            </datatable>
          <CommonModal ref="showModal" size="xl" :onHideOnlyX="true" @bHideModalHeaderClose="formClear" v-if="checkPermission('studentclubpresidentapplication_show')">
            <template v-slot:CommonModalTitle>
              {{ $t('show').toLocaleUpperCase('tr-TR') }}
            </template>
            <template v-slot:CommonModalContent>
              <show-form :formId="formId"
                         v-if="formProcess=='show'"
              />
            </template>
          </CommonModal>
            <CommonModal ref="createFormModal" size="lg" :onHideOnlyX="true" @bHideModalHeaderClose="formClear">
                <template v-slot:CommonModalTitle>
                    {{ $t('new').toUpper() }}
                </template>
                <template v-slot:CommonModalContent>
                    <create-form :formId="id" @createFormSuccess="createFormSuccess"
                                 v-if="formProcess=='create'"
                    />
                </template>
            </CommonModal>
            <CommonModal ref="updateFormModal" size="lg" :onHideOnlyX="true" @bHideModalHeaderClose="formClear">
                <template v-slot:CommonModalTitle>
                    {{ $t('edit').toUpper() }}
                </template>
                <template v-slot:CommonModalContent>
                    <update-form :formId="formId" @updateFormSuccess="updateFormSuccess" v-if="formProcess == 'update'" />
                </template>
            </CommonModal>
        </app-layout>
    </div>
</template>
<script>
// Template
import AppLayout from "@/layouts/AppLayout.vue"
import Header from "@/layouts/AppLayout/Header.vue"
import HeaderMobile from "@/layouts/AppLayout/HeaderMobile.vue"

// Components
import Datatable from "@/components/datatable/Datatable.vue";
import CommonModal from "@/components/elements/CommonModal.vue";

// Pages
import CreateForm from './CreateForm.vue';
import UpdateForm from './UpdateForm.vue';
import ShowForm from './ShowForm.vue'

// Services
import StudentClubService from "@/services/StudentClubService";
import qs from "qs";


export default {
    components: {
        AppLayout,
        Header,
        HeaderMobile,
        Datatable,
        CommonModal,

        UpdateForm,
        CreateForm,
        ShowForm,

    },
    metaInfo() {
        return {
            title: this.$t('members')
        }
    },

    data() {
        return {
            id: this.$route.params.id,
            data: null,
            datatable: {
                isLoading: false,
                columns: [
                    {
                        label: '',
                        field: 'buttons',
                        html: true,
                        sortable: false,
                        tdClass: 'p-0 text-center w-40 align-middle',
                        buttons: [
                            {
                              text: this.$t('show'),
                              class: 'ri-search-eye-line',
                              permission: 'studentclubpresidentapplicationuser_show',
                              callback: (row) => {
                                this.showForm(row.id);
                              }
                            },
                            {
                                text: this.$t("edit"),
                                class: "ri-edit-box-line",
                                permission: 'studentclubpresidentapplicationuser_update',
                                callback: (row) => {
                                    this.updateFormShow(row.id);
                                },
                            },
                            {
                                text: this.$t('delete'),
                                class: 'ri-delete-bin-7-line align-middle top-minus-1 mr-3 text-muted',
                                permission: "studentclubpresidentapplicationuser_delete",
                                callback: (row) => {
                                    this.formDelete(row.id)
                                }
                            }
                        ]
                    },
                    {
                        label: this.toUpperCase('id'),
                        field: 'id',
                        hidden: true,
                    },
                    {
                        label: this.toUpperCase('members'),
                        field: 'student_number',
                        hidden: false,
                        formatFn: (value,row) => {
                            return row.student_number+' - '+row.name+' '+row.surname
                        }
                    },
                    {
                        label: this.toUpperCase('status'),
                        field: 'status',
                        formatFn: (row) => {
                            if (row === 'approved') {
                                return this.$t('approved');
                            } else if (row === 'waiting') {
                                return this.$t('waiting');
                            } else if (row === 'declined') {
                                return this.$t('declined');
                            } else {
                                return '';
                            }
                        },
                        hidden: false,
                    }
                ],
                rows: [],
                total: 0,
                filterStatus: true,
                showTable: false,
                queryParams: {
                    filter: {},
                    sort: 'id',
                    page: 1,
                    limit: 20
                }
            },
            formProcess: null,
            formId: null,
            form: {},
        }
    },
    created() {
        this.getRows()
    },
    methods: {
        filter() {
            this.datatable.queryParams.page = 1;
            this.getRows();
        },
        onPageChange(params) {
            this.datatable.queryParams.page = params.currentPage;
            this.getRows();
        },
        onPerPageChange(params) {
            this.datatable.queryParams.limit = params.currentPerPage;
            this.datatable.queryParams.page = 1;
            this.getRows();
        },
        changeColumn(key) {
            this.datatable.columns[key].hidden = this.datatable.columns[key].hidden == true ? false : true;
        },
        onSortChange(params) {
            const sortType = params[0].type == 'desc' ? '-' : '';
            this.datatable.queryParams.sort = sortType + params[0].field
            this.getRows();
        },
        getRows() {
            this.datatable.showTable = true;
            this.datatable.isLoading = true;

            const config = {
                params: {
                    filter: {
                        student_club_president_application_id: this.id,
                    },
                },
                paramsSerializer: (params) => qs.stringify(params, {encode: false}),
            };
            return StudentClubService.getAllPresidentUsers(config)
                .then((response) => {
                    this.datatable.rows = response.data.data
                })
                .finally(() => {
                    this.datatable.isLoading = false;
                });
        },
        // Clear
        formClear() {
            this.formId = null
            this.formProcess = null
        },
        // Create
        createFormShow() {
            this.formId = null
            this.formProcess = 'create'
            this.$refs.createFormModal.$refs.commonModal.show()
        },
        updateFormShow(id) {
            this.formId = id
            this.formProcess = 'update'
            this.$refs.updateFormModal.$refs.commonModal.show()
        },
      showForm(id) {
        this.formId = id
        this.formProcess = 'show'
        this.$refs.showModal.$refs.commonModal.show()
      },
        createFormSuccess() {
            this.$refs.createFormModal.$refs.commonModal.hide()
            this.getRows()
            this.formClear()
        },
        updateFormSuccess() {
            this.$refs.updateFormModal.$refs.commonModal.hide()
            this.getRows()
            this.formClear()
        },
        formDelete(id) {
            this.$swal
                .fire({
                    text: this.$t('are_you_sure_to_delete'),
                    showCancelButton: true,
                    confirmButtonText: this.$t('yes'),
                    cancelButtonText: this.$t('no'),
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        StudentClubService.delPresidentUsers(id)
                            .then(response => {
                                this.$toast.success(this.$t('api.' + response.data.message));
                                this.getRows();
                                this.formClear();
                            })
                            .catch(error => {
                                this.$toast.error(this.$t('api.' + error.data.message));
                            });
                    }
                })
        },

    }
}
</script>

